import { c as _c } from "react/compiler-runtime";
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { ShowMoreToggleClient } from './ShowMoreToggleClient';
export type ShowMoreToggleProps = {
  height?: string;
  /** The toggle text that shows when the content is not fully expanded */
  showMoreText?: string;
  /** The toggle text that shows when the content is fully expanded */
  showLessText?: string;
};
export function ShowMoreToggle(t0) {
  const $ = _c(7);
  const {
    props: t1
  } = t0;
  const {
    children,
    height,
    showMoreText,
    showLessText
  } = t1;
  let t2;
  if ($[0] !== children) {
    t2 = renderStructuredContent(children);
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== height || $[3] !== showLessText || $[4] !== showMoreText || $[5] !== t2) {
    t3 = <ShowMoreToggleClient height={height} showMoreText={showMoreText} showLessText={showLessText}>{t2}</ShowMoreToggleClient>;
    $[2] = height;
    $[3] = showLessText;
    $[4] = showMoreText;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}